import { Percent } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { AmazonSalesResponse } from "reedy-data/api";
import { formatNumber, formatPercent } from "~/utils/formatting";
import { Text } from "~/components/text";
import { SummaryCard } from "./summary-card";

export const AmazonConversionCard = ({
  sales,
  isLoading,
  unavailableReason,
  onClick,
}: {
  sales?: AmazonSalesResponse;
  isLoading?: boolean;
  unavailableReason?: string;
  onClick: () => void;
}) => {
  const { t } = useTranslation(["productDetails"]);

  const summary = sales?.summary;
  const detail =
    !unavailableReason && summary
      ? {
          summary: t("salesData.summaryCards.amazonConversion.pageViews"),
          value:
            summary.totalPageViews != null
              ? formatNumber(summary.totalPageViews)
              : "—",
        }
      : undefined;

  return (
    <SummaryCard
      testId="summary-card-amazon-conversion"
      icon={<Percent className="h-4 w-4" aria-hidden />}
      title={t("salesData.summaryCards.amazonConversion.title")}
      isLoading={isLoading}
      badge={null}
      body={
        sales ? (
          <Text
            as="span"
            variant="pageHeading"
            numeric="tabular"
            className="truncate"
          >
            {summary?.averageConversionRate != null
              ? formatPercent(summary.averageConversionRate)
              : "—"}
          </Text>
        ) : undefined
      }
      series={
        sales
          ? [
              {
                key: "summary-card-amazon-conversion",
                color: "var(--chart-6)",
                // Missing buckets stay null so the sparkline bridges the gap
                // instead of drawing a false drop to 0% (matches the rank card).
                points: sales.buckets.map(
                  (bucket) => bucket.conversionRate ?? null,
                ),
              },
            ]
          : undefined
      }
      unavailableReason={unavailableReason}
      detailSummary={detail?.summary}
      detailValue={detail?.value}
      jumpHint={t("salesData.summaryCards.jumpToAmazonChart")}
      onClick={onClick}
    />
  );
};
